const premiumProxies = `{
  "session": 1234
}`;

export default premiumProxies;
